export default "__VITE_ASSET__7wdbKtc9__"